import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/talent',
    authDomain: 'authenticate.staging.seek.com',
    clientDomain: 'my.employer.staging.seek.com',
    clientId: 'kluLcBIyz3rFzz8zIzF8tTFTDcNZ96PZ',
    environment: 'dev',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    contactUs: {
        en: 'https://www.jobstreet.com/about-us/contact-us-malaysia/',
    },
    siteName: siteNames.employer.seek.my,
    zone: getZoneFromSite(siteNames.employer.seek.my),
    brand: Brand.SEEK,
    product: Product.HIRER,
};
//# sourceMappingURL=my_employer_staging_seek_com.js.map